import * as Immutable from 'immutable';
import {
  GET_SIGNATURE_DATA_ABORTED,
  GET_SIGNATURE_DATA_REQUESTED,
  GET_SIGNATURE_DATA_COMPLETED,
  GET_SIGNATURE_DATA_FAILED,
  SET_SIGNATURE_DATA_REQUESTED,
  SET_SIGNATURE_DATA_COMPLETED,
  SET_SIGNATURE_DATA_FAILED,
} from '../../actions/actioncentersignature/types';

const schema = {
  error: null,
  data: null,
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SIGNATURE_DATA_ABORTED:
      return state.set('error', null).set('gettingdata', false);

    case GET_SIGNATURE_DATA_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_SIGNATURE_DATA_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_SIGNATURE_DATA_FAILED:
      return state
        .set('gettingdata', false)
        .set('gotdata', false)
        .set('error', action.payload);

    case SET_SIGNATURE_DATA_REQUESTED:
      return state
        .set('error', null)
        .set('data', null)
        .set('settingdata', true);

    case SET_SIGNATURE_DATA_COMPLETED:
      return state
        .set('error', null)
        .set('settingdata', false)
        .set('setdata', true)
        .set('data', action.payload);

    case SET_SIGNATURE_DATA_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
